<template>
  <div class="sidebar-wrapper d-flex justify-content-between flex-column flex-grow-1">
    <div class="p-2">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        aria-controls="sidebar-add-new-event"
        :aria-expanded="String(isEventHandlerSidebarActive)"
        variant="primary"
        block
        @click="$emit('update:isEventHandlerSidebarActive', true);"
      >
      {{ $t('Add Booking') }}
      </b-button>
      <div class="mt-3">
        <h5 class="app-label section-label mb-1">
          <span class="align-middle">{{ $t('Room') }}</span>
        </h5>
        <b-form-group>
          <b-form-checkbox-group
            v-model="selectedCalendars"
            name="event-filter"
            stacked
          >

            <b-form-checkbox
              @change="emit_now"
              v-for="item in calendarOptions"
              :key="item.label"
              name="event-filter"
              :value="item.id"
              class="mb-1"
              :class="`custom-control-${item.color}`"
            >
              <b>{{ item.label }}</b>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

      </div>
    </div>
    <b-img :src="require('@/assets/images/pages/calendar-illustration.png')" />
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BFormCheckboxGroup, BFormCheckbox, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import useCalendarSidebar from './useCalendarSidebar'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BFormCheckboxGroup,
  },
  props: {
    isEventHandlerSidebarActive: {
      type: Boolean,
      require: true,
    },
  },
  created() {
  //  console.clear()
    this.get_room()
  },
  methods: {
    emit_now() {
      console.log("emit")
      this.$emit('fetch',this.selectedCalendars)
    },
    get_room() {
      // this.$http.get(process.env.VUE_APP_API_BASE+`/rooms/?enabled=y&center_id=`+ this.$store.getters['center/currentCenterId'])
      //   .then(res => {
      //     if (process.env.VUE_APP_VERSION != res.data.version) {
      //       this.$router.go(0);
      //     }
      //     this.calendarOptions = res.data.rooms
      //   })
      this.calendarOptions =
        [
          {id:1,label:'Table 1'},
          {id:2,label:'Table 2'},
          {id:3,label:'Table 3'},
          {id:4,label:'Table 4'},
          {id:5,label:'Table 5'},
          {id:6,label:'Table 6'},
          {id:7,label:'Table 7'},
          {id:8,label:'Table 8'},
          {id:9,label:'Table 9'},
        ]
    },
  },
  data() {
    return {
      calendarOptions:[],
      selectedCalendars:[],
    }
  },
}
</script>

<style>

</style>
